export const titles: Record<string, string> = {
  CARD_INVALID_CVC: 'Invalid CVC',
  CARD_INVALID_SECURITY_CODE: 'Invalid Security Code',
  CARD_INVALID_NUMBER: 'Invalid Card Number',
  CARD_INVALID_MONTH: 'Invalid Expiration Month',
  CARD_INVALID_YEAR: 'Invalid Expiration Year',
  POSTAL_CODE_INVALID: 'Invalid Postal Code',
  CARD_INVALID_PIN: 'Invalid PIN',
  CARD_PREPAID_NOT_ALLOWED:
    'We are unable to process payments via prepaid cards',
  SOMETHING_WENT_WRONG: 'Something went wrong...',
  GENERIC_ERROR: "We aren't able to process your payment",
  PAYMENT_METHOD_NOT_SUPPORTED: 'Payment method not supported',
  CARD_DECLINED_TOO_MANY_TIMES: 'Card declined too many times',
  COUPON_EXPIRED: 'Coupon expired',
  EMAIL_INVALID: 'Invalid e-mail address',
  CARD_EXPIRED: 'Your card is expired',
  CARD_ADDRESS_DOES_NOT_MATCH: 'Incorrect address',
  TOO_MANY_PAYMENT_REQUESTS: 'Too many payment attempts',
  ACCOUNT_CANNOT_BE_USED: 'Account cannot be used',
  BILLING_ADDRESS_MISSING: 'Billing address is missing',
  CARD_3DS_DECLINED: '3DS Validation Declined',
  PAYMENT_METHOD_TEMPORARILY_UNAVAILABLE:
    'Payment method temporarily unavailable',
  ACCOUNT_SEPA_NOT_SUPPORTED: 'SEPA not supported for this account',
  ADDRESS_SHIPPING_INVALID: 'Invalid shipping address',
  CARD_NOT_SUPPORTED: 'Your card is not supported',
  CARD_NOT_ENOUGH_FUNDS: 'Not enough funds',
  CARD_DO_NOT_HONOR: 'Transaction cannot be completed',
  DUPLICATE_TRANSACTION: 'Duplicated transaction',
  CARD_CANNOT_BE_USED: 'This card cannot be used',
  CARD_NOT_ENOUGH_LIMIT: 'Not enough limit',
  CARD_PIN_TRIES_EXCEEDED: 'PIN tries exceeded',
  CARD_TRY_AGAIN_LATER: 'Too many attempts',
};
